import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { LocationIcon } from "../../components/icons";
import apiService from "../../service/apiService";
import Tickets from "./Tickets";
import { Chip, formatHour } from "../../helpers/general";
import { ACCENT, Card, cardStyle, InfoRow } from "../Places/PlacesTable";

export default function Event() {
  const { eventId } = useParams();

  const { data } = useQuery<Events>(
    ["getEvent", eventId],
    () => apiService.MakeGetRequest(`events/${eventId}`, "", { mode: "edit" }),
    { enabled: Boolean(eventId) },
  );

  const start = formatHour(data?.startingHour);
  const end = formatHour(data?.endingHour);
  const hours = start && end ? `${start} – ${end}` : start || end;

  const instagramHandle = data?.instagramUrl?.replace(
    /^https?:\/\/(www\.)?instagram\.com\//,
    "",
  );

  return (
    <main className="px-2">
      {/* Header */}
      <div style={cardStyle} className="mb-3">
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
          <div style={{ minWidth: 0 }}>
            <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
              {data?.type?.label && (
                <Chip tone="warning">{data.type.label}</Chip>
              )}
              {start && <Chip>À partir de {start}</Chip>}
            </div>
            <h4 className="fs-3 fw-bold mb-1 text-capitalize">{data?.name}</h4>
            {data?.address && (
              <div
                className="d-flex align-items-center gap-2 text-muted"
                style={{ fontSize: 13 }}
              >
                <LocationIcon width="18" height="18" />
                {data.address}
              </div>
            )}
          </div>

          {eventId && (
            <a
              href={`/offers/update/event-offer/${eventId}`}
              className="btn btn-outline-danger rounded-pill px-3"
            >
              Modifier
            </a>
          )}
        </div>
      </div>

      <div className="row g-3">
        {/* About */}
        <div className="col-12">
          <Card title="À propos">
            {data?.description ? (
              <div
                className="mb-0"
                style={{ fontSize: 14, color: "#555", whiteSpace: "pre-wrap" }}
                dangerouslySetInnerHTML={{ __html: data.description }}
              />
            ) : (
              <span className="text-muted">Aucune description.</span>
            )}
          </Card>
        </div>

        {/* Contact */}
        <div className="col-lg-6">
          <Card title="Emplacement et coordonnées">
            <InfoRow iconNode={<LocationIcon width="16" height="16" />}>
              {data?.address}
            </InfoRow>
            <InfoRow icon="clock">{hours}</InfoRow>
            <InfoRow
              icon="phone"
              href={data?.phone ? `tel:${data.phone}` : undefined}
            >
              {data?.phone}
            </InfoRow>
            <InfoRow
              icon="envelop"
              href={data?.email ? `mailto:${data.email}` : undefined}
            >
              {data?.email}
            </InfoRow>
            <InfoRow icon="web" href={data?.website}>
              {data?.website
                ?.replace(/^https?:\/\/(www\.)?/i, "")
                .replace(/\/$/, "")}
            </InfoRow>
            <InfoRow icon="instagram" href={data?.instagramUrl}>
              {instagramHandle && `@${instagramHandle.replace(/\/$/, "")}`}
            </InfoRow>
          </Card>
        </div>

        {/* Ticket delivery */}
        <div className="col-lg-6">
          <Card title="Modes d'obtention des billets">
            <div className="d-flex gap-3">
              <Chip tone="danger">E-ticket</Chip>
              <p className="mb-0 text-muted" style={{ fontSize: 14 }}>
                Imprimez vos billets chez vous dès la fin de votre commande et
                recevez-les également par email en format PDF.
              </p>
            </div>
          </Card>
        </div>
      </div>

      {/* Tickets */}
      {data?.services && data.services.length > 0 && (
        <section className="mt-4">
          <h6
            className="fw-semibold mb-3"
            style={{ fontSize: 12, color: "#777", letterSpacing: "0.04em" }}
          >
            BILLETS
          </h6>
          <div className="d-flex flex-column gap-3">
            {data.services.map((service) => (
              <div
                key={service.id}
                style={{ ...cardStyle, borderLeft: `4px solid ${ACCENT}` }}
              >
                <Tickets service={service} />
              </div>
            ))}
          </div>
        </section>
      )}
    </main>
  );
}
